var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('NavBar'),_c('Jumbotron'),_c('Education'),_c('Experience'),_c('Skills'),_c('Projects'),_c('Achievements'),_c('Activities'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }